var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property } from 'lit/decorators.js';
import { LitElement, nothing } from 'lit';
import { fetchApiData, customElement, stringDecoder, PICInput, loadPage, submitEventHandler, PICModal, PIC, PICWebTable, PICLoadPage, fetchFormData, Util, fetchRestApi, openChoiceBox } from '../Internals';
import { downloadFromDownloadSrv, downloadFromPDFSrv } from '../../util/Util';
let PICAction = class PICAction extends LitElement {
    set eventFnc(iFunc) {
        this.eventFnc_ = iFunc;
    }
    get eventFnc() {
        return this.eventFnc_;
    }
    constructor(type, eventFnc) {
        super();
        this.parms_ = '';
        if (type)
            this.type_ = type;
        if (eventFnc)
            this.eventFnc = eventFnc;
    }
    set actionOptions(iOptions) {
        if (iOptions) {
            if (iOptions.type)
                this.type_ = iOptions.type;
            if (iOptions.event)
                this.event_ = iOptions.event;
            if (iOptions.eventFnc)
                this.eventFnc = iOptions.eventFnc;
            if (iOptions.id)
                this.id_ = iOptions.id;
            if (iOptions.pp)
                this.progpath_ = iOptions.pp;
            if (iOptions.parms)
                this.parms_ = iOptions.parms;
            if (iOptions.cmdData)
                this.cmdData = iOptions.cmdData;
            if (iOptions.preEvent)
                this.preEventFnc_ = this.getEventFunction(iOptions.preEvent);
            if (iOptions.postEvent)
                this.postEventFnc_ = this.getEventFunction(iOptions.postEvent);
            if (iOptions.params) {
                this.parms_ = '';
                iOptions.params.forEach(par => {
                    this.parms_ += ',' + par.key + '=' + par.val;
                });
            }
            try {
                if (iOptions.apiData)
                    this.apiData = JSON.parse(atob(iOptions.apiData));
                /* If preveent or postevent has been added via params */
                if (this.apiData) {
                    if (this.apiData.preEvent) {
                        delete this.apiData.preEvent;
                    }
                    if (this.apiData.postEvent) {
                        this.postEventFnc_ = this.getEventFunction(this.apiData.postEvent);
                        delete this.apiData.postEvent;
                    }
                }
            }
            catch (_a) {
                console.log('AtoB failed');
            }
            if (this.cmdData) {
                if (this.cmdData.preEvent) {
                    this.preEventFnc_ = this.getEventFunction(this.cmdData.preEvent);
                    this.preEventFnc_ = this.getEventFunction(this.apiData.preEvent);
                }
                if (this.cmdData.postEvent) {
                    this.postEventFnc_ = this.getEventFunction(this.cmdData.postEvent);
                }
            }
        }
    }
    connectedCallback() {
        super.connectedCallback();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    //Loadbearing function - this is to keep util import of same function, so it doesnt accidentally get deleted
    cowSweat(moo) {
        downloadFromPDFSrv(moo);
        downloadFromDownloadSrv(moo);
    }
    getEventFunction(iObj) {
        let element = PIC.getInstance.findElementByIdDeep(iObj.elementId);
        if (iObj.elementFunction === 'downloadFromPDFSrv') {
            return downloadFromPDFSrv.bind(this);
        }
        else if (iObj.elementFunction === 'downloadFromDownloadSrv') {
            return downloadFromDownloadSrv.bind(this);
        }
        else if (element && element[iObj.elementFunction]) {
            return element[iObj.elementFunction].bind(element);
        }
        else if (this[iObj.elementFunction]) {
            return this[iObj.elementFunction].bind(this);
        }
        else
            return undefined;
    }
    handleCellTextCopy(cellText) {
        navigator.clipboard.writeText(cellText);
    }
    getLinkedFld() {
        if (this.boundElm)
            return this.boundElm;
        let tmp = this.getRootNode().querySelector('#' + this.bndFldID_);
        if (tmp) {
            return tmp;
        }
        return null;
    }
    registerEventFunction() {
        var _a, _b, _c;
        let fld = this.getLinkedFld();
        let extraParm = '';
        if (fld && fld instanceof PICInput)
            extraParm = ',' + fld.id + '=' + fld.submitValue;
        let tmpFnc;
        switch (this.type_) {
            case 'doSubmit':
                if (this.event_)
                    tmpFnc = (e) => submitEventHandler(e, this.event_);
                break;
            case 'loadPage':
                if (this.progpath_) {
                    let options = {};
                    options['isNew'] = PIC.getInstance.webVersion == '3';
                    if (this.event_)
                        options['closeEvent'] = this.event_;
                    if (fld) {
                        let rNode = fld.getRootNode();
                        if (rNode instanceof ShadowRoot && rNode.host instanceof PICLoadPage) {
                            options['parentSessId'] = (_a = rNode.host) === null || _a === void 0 ? void 0 : _a.selfSessId;
                        }
                        else if (rNode instanceof PICModal && rNode.parent instanceof PICLoadPage) {
                            options['parentSessId'] = (_b = rNode.parent) === null || _b === void 0 ? void 0 : _b.selfSessId;
                        }
                    }
                    // this runs though all the possible params from form, to give loadpage all the current selected values
                    tmpFnc = (e) => {
                        var _a, _b, _c, _d;
                        let deformForm = (_b = (_a = this.getFormData(e)) === null || _a === void 0 ? void 0 : _a.split('&').filter(e => { var _a; return ['moduleId', 'eventid', 'SessionCode', 'SystemId', 'CurLang', 'Subwin', 'datemode', 'WebVersion', 'ctrl', 'appVersion'].indexOf((_a = e.split('=')[0]) !== null && _a !== void 0 ? _a : '') < 0; }).join(',')) !== null && _b !== void 0 ? _b : '';
                        this.parms_ = (_c = this.parms_) !== null && _c !== void 0 ? _c : '';
                        deformForm = [...(_d = this.parms_) === null || _d === void 0 ? void 0 : _d.split(','), ...extraParm === null || extraParm === void 0 ? void 0 : extraParm.split(','), ...deformForm === null || deformForm === void 0 ? void 0 : deformForm.split(',')].join(',');
                        loadPage(this.progpath_, deformForm, options);
                    };
                }
                break;
            case 'apiRequest':
                if (this.progpath_) {
                    if (this.preEventFnc_) {
                        this.apiData = Object.assign(Object.assign({}, this.apiData), this.preEventFnc_());
                    }
                    let tmp = {
                        postBody: this.apiData
                    };
                    /*TODO: this will only work if the url is on the same system as called, make this a parameter like userest in table */
                    let isRest = false;
                    if (this.progpath_.includes('v1/' + PIC.systemId)) {
                        tmp.path = this.progpath_;
                        tmp.formatOutput = 'text'; //... mate
                        tmp.restVersion = 'v1';
                        isRest = true;
                    }
                    tmpFnc = () => {
                        fetchApiData(isRest ? '' : this.progpath_, tmp).then((data) => {
                            if (this.postEventFnc_)
                                this.postEventFnc_(data);
                        });
                    };
                }
                break;
            case 'internal':
                if (typeof this.eventFnc === 'function') {
                    tmpFnc = this.eventFnc;
                }
                else {
                    try {
                        tmpFnc = this.getEventFunction(this.eventFnc);
                    }
                    catch (_d) {
                    }
                }
                break;
            case 'command':
                switch (this.event_) {
                    case 'closeModal':
                        if (fld) {
                            tmpFnc = () => {
                                if (fld.getRootNode().firstElementChild instanceof PICModal) {
                                    fld.getRootNode().firstElementChild.closeModal(true);
                                }
                            };
                        }
                        else { //attempt to close outermost modal
                            const modals = PIC.getInstance.findElementsByTagDeep('PIC-MODAL');
                            if (modals.length > 0) {
                                const outerModal = modals.slice(-1)[0];
                                outerModal.closeModal(true, { forceSubmit: true });
                            }
                            tmpFnc = () => { };
                        }
                        break;
                    case 'createAndOpenPrint':
                        tmpFnc = () => this.createAndOpenPrint(this.parms_);
                        break;
                    case 'openPrint':
                        tmpFnc = () => this.openPrint(this.parms_);
                        break;
                    case 'downloadb64':
                        const data = (_c = this.cmdData) === null || _c === void 0 ? void 0 : _c.data;
                        tmpFnc = () => this.openBase64File(data, this.parms_);
                        break;
                    case 'refreshTable':
                        tmpFnc = () => {
                            try {
                                let c = JSON.parse(`{"${this.parms_.replace(new RegExp('=', 'g'), '":"').replace(new RegExp(',', 'g'), '","')}"}`);
                                if (c.tableid) {
                                    let table = PIC.getInstance.findElementByIdDeep(c.tableid);
                                    //Override function of table in order to load data from bundledeploy servlet
                                    if (table) {
                                        // table.data = {headers: [], data: []};
                                        table.loadData = async (src) => {
                                            if (typeof src === 'object') {
                                                table.responseTabledata = src; //data or tabledata?
                                            }
                                            else if (typeof src === 'string') {
                                                let options = {
                                                    systemId: null,
                                                    errorReturn: true,
                                                    formatOutput: 'json',
                                                    url: src + c.mode,
                                                    postBody: {
                                                        mode: c.mode,
                                                        repository: c.repository,
                                                        branch: c.branch,
                                                        clean: c.clean,
                                                        file: c.file,
                                                        version: c.version,
                                                        betaBranch: c.betaBranch,
                                                        isPicBundle: c.isPicBundle
                                                    },
                                                };
                                                table.isLoading = true;
                                                if (table.isConnected, src, options) {
                                                    fetchApiData(undefined, options).then(data => {
                                                        if (!!data[table.dataRootName]) {
                                                            table.data = data[table.dataRootName];
                                                        }
                                                        else
                                                            table.data = data;
                                                        if (table.refreshTimer) {
                                                            PIC.getInstance.setTimeout(table.getData.bind(table, true), table.refreshTimer);
                                                        }
                                                        table.isLoading = false;
                                                    }).catch(err => {
                                                        table.dataLoadError = true;
                                                        table.data = { headers: [], data: [] };
                                                        table.isLoading = false;
                                                        table.requestUpdate();
                                                    });
                                                }
                                                else {
                                                    return Promise.reject('table is disconnected');
                                                }
                                            }
                                            else {
                                                table.isLoading = false;
                                                throw new Error(`Error. Trying to load data that is neither tabledata nor a url`);
                                            }
                                            return true;
                                        };
                                        table.loadData(location.href);
                                    }
                                }
                            }
                            catch (err) {
                                console.log('could not parse params from', this.parms_);
                            }
                        };
                        break;
                    case 'dispatchEvent':
                        tmpFnc = () => {
                            if (this.cmdData && this.cmdData.event) {
                                //find component
                                let element;
                                if (document.activeElement instanceof PICLoadPage)
                                    element = PIC.getInstance.findElementByIdDeep(this.cmdData.id, document.activeElement);
                                if (!element)
                                    element = PIC.getInstance.findElementByIdDeep(this.cmdData.id);
                                if (element)
                                    element.dispatchEvent(new CustomEvent(this.cmdData.event, { bubbles: true, cancelable: false, detail: this.cmdData }));
                            }
                        };
                        break;
                    case 'toggleNavDrawer':
                        if (!this.cmdData)
                            break;
                        tmpFnc = () => {
                            if (this.cmdData && this.cmdData.data) {
                                let elements = PIC.getInstance.findElementsByTagDeep('PIC-NAVDRAWER');
                                if (elements.length > 0)
                                    elements[0].dispatchEvent(new CustomEvent(this.cmdData.data.event, { bubbles: true, cancelable: false }));
                            }
                        };
                        break;
                    case 'setTheme':
                        if (!this.cmdData)
                            break;
                        tmpFnc = () => {
                            var _a, _b, _c;
                            const requested = (_b = (_a = this.cmdData) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.theme;
                            const usrCfg = PIC.getInstance.userConfig;
                            if (!usrCfg)
                                return;
                            let next;
                            if (requested === 'toggle')
                                next = usrCfg.theme === 'dark' ? 'light' : 'dark';
                            else if (requested === 'light' || requested === 'dark')
                                next = requested;
                            else {
                                console.error('Invalid theme via command, expected light|dark|toggle', (_c = this.cmdData) === null || _c === void 0 ? void 0 : _c.data);
                                return;
                            }
                            //The setter does all three steps: sets data-theme on
                            //<html>, mirrors to localStorage (so the next page
                            //load paints in the right theme) and persists via
                            //incl/settings - same path as the Settings switch.
                            usrCfg.theme = next;
                        };
                        break;
                    case 'callComponent':
                        tmpFnc = () => {
                            if (this.cmdData && this.cmdData.event) {
                                if (this.preEventFnc_)
                                    this.preEventFnc_(this.cmdData);
                                let func = this.getEventFunction({ elementId: this.cmdData.id, elementFunction: this.cmdData.event });
                                if (func)
                                    func(this.cmdData);
                                if (this.postEventFnc_)
                                    this.postEventFnc_(this.cmdData);
                            }
                        };
                        break;
                    case 'openMail':
                        if (this.cmdData) {
                            try {
                                let data = this.cmdData.data;
                                let emailLink = document.createElement('a');
                                let link = `mailto:${data.mailTo}`;
                                let hasOtherData = false;
                                if (data.mailCC.length > 0) {
                                    link += `?cc=${data.mailCC}`;
                                    hasOtherData = true;
                                }
                                if (data.mailBCC.length > 0) {
                                    link += `${hasOtherData ? '&' : '?'}bcc=${data.mailBCC}`;
                                    hasOtherData = true;
                                }
                                if (data.mailSubject.length > 0) {
                                    link += `${hasOtherData ? '&' : '?'}subject=${data.mailSubject}`;
                                    hasOtherData = true;
                                }
                                if (data.mailBody.length > 0) {
                                    link += `${hasOtherData ? '&' : '?'}body=${data.mailBody}`;
                                }
                                emailLink.href = link;
                                emailLink.click();
                            }
                            catch (e) {
                                //failed 
                                console.error(e);
                            }
                        }
                        break;
                    case 'handleMessage': //handles choiceboxes send via cmd (exportJson), like errorMsg in fetchformdata
                        if (!this.cmdData)
                            break;
                        try {
                            let data = this.cmdData.data; //add other properties as necessary
                            openChoiceBox('pic-choicebox[choicebox-x]', data.cb);
                        }
                        catch (error) {
                            console.error('Could not open choicebox via command', this.cmdData.data);
                        }
                        break;
                    case 'copyToClipboard': // Copy to user clipboard
                        if (!this.cmdData)
                            break;
                        try {
                            let data = this.cmdData.data;
                            if (typeof data.cb !== "string") {
                                data.cb = JSON.stringify(data.cb);
                            }
                            this.handleCellTextCopy(data.cb);
                        }
                        catch (error) {
                            console.error('Could not copy to clipboard via command', this.cmdData.data);
                        }
                        break;
                    case 'handleEventTimer':
                        if (!this.cmdData)
                            break;
                        let interval = Number(this.cmdData.data.interval);
                        let event = this.cmdData.data.event;
                        if (!interval || isNaN(interval) || !event)
                            break;
                        tmpFnc = () => {
                            if (this.cmdData && event) {
                                try {
                                    PIC.getInstance.setTimeout(() => submitEventHandler(undefined, event), interval);
                                }
                                catch (error) {
                                    console.error('Could not set interval via command', this.cmdData.data);
                                }
                            }
                        };
                        break;
                    case 'renderComponent':
                        //currently just for PICLoad, but could easily be expanded? :)
                        if (!this.cmdData)
                            break;
                        try {
                            let component = atob(this.cmdData.data);
                            const parser = new DOMParser();
                            const doc = parser.parseFromString(component, "text/html");
                            const componentHTML = doc.body.firstElementChild;
                            if (componentHTML == null)
                                break;
                            let mainBody = document.querySelector('.pic-mainbody');
                            mainBody === null || mainBody === void 0 ? void 0 : mainBody.appendChild(componentHTML);
                        }
                        catch (e) { }
                        break;
                    default:
                        //not valid
                        break;
                }
                break;
            default:
                if (this.event_) {
                    tmpFnc = (e) => submitEventHandler(e, this.event_);
                }
                break;
        }
        if (tmpFnc) {
            this.eventFnc_ = tmpFnc;
            return true;
        }
        else {
            this.eventFnc_ = () => { };
            return false;
        }
    }
    triggerEvent(e) {
        let isValid = this.registerEventFunction();
        if (isValid) {
            this.eventFnc_(e);
        }
        else {
            console.log('invalidAction', this);
        }
        return isValid;
    }
    requestfileposter(url, body, sys) {
        var req = new XMLHttpRequest();
        if (!url) {
            url = window.location.href;
        }
        return new Promise(function (resolve, reject) {
            req.open('POST', url);
            req.responseType = 'blob';
            req.setRequestHeader('picsystem', sys);
            req.onload = function () {
                if (req.status == 200) {
                    resolve(req);
                }
                else {
                    reject(Error(req.statusText));
                }
            };
            req.onerror = function () {
                reject(Error('Network Error'));
            };
            req.send(body);
        });
    }
    /**
     * Request a print from the backend, it needs to return the file to download (after potentially creating it)
     *
     */
    createAndOpenPrint(iData) {
        try {
            let ndata = JSON.parse(atob(iData));
            if (ndata.hasOwnProperty('notekey')) {
                const { notekey, username, timestamp, filetype, systemId, newFileName, openInBrowser } = ndata;
                const url = `/filestore/DownloadSrv?notekey=${notekey}&username=${username}&timestamp=${timestamp}&filetype=${filetype}&system=${systemId !== null && systemId !== void 0 ? systemId : PIC.systemId}`;
                this.openFile(url, `${newFileName}.${filetype}`, openInBrowser);
            }
            else {
                const { reqPath, reqParms, openInBrowser } = ndata;
                fetchRestApi(reqParms, {
                    httpMethod: 'POST',
                    path: reqPath,
                    picsystem: PIC.systemId,
                    restVersion: 'base'
                }).then(r => r.text())
                    .then(d => {
                    let data;
                    try {
                        data = JSON.parse(d);
                    }
                    catch (e) {
                        data = d;
                    }
                    if (typeof data === 'string' && data.length === 0)
                        throw Error('Failed to parsed Print Response');
                    const fileurl = this.parseNoteKey(data);
                    this.openFile(fileurl.url, fileurl.filename, openInBrowser);
                });
            }
        }
        catch (e) {
            throw Error('Failed to parsed Print Action');
        }
    }
    parseNoteKey(data) {
        let notekey, username, timestamp, filetype;
        let system = PIC.systemId;
        let newFileName = `Print`;
        if (typeof data === 'string') {
            notekey = data.split('-')[0];
            username = data.split('-')[1];
            timestamp = data.split('-')[2].split('.')[0];
            filetype = data.split('-')[2].split('.')[1];
            newFileName = `Print.${filetype}`;
        }
        else {
            notekey = data.notekey;
            username = data.username;
            timestamp = data.timestamp;
            filetype = data.filetype;
            if (typeof data.systemId === 'string' && data.systemId.length > 0)
                system = data.systemId;
            if (typeof data.newFileName === 'string' && data.newFileName.length > 0)
                newFileName = `${data.newFileName}.${filetype}`;
            else
                newFileName = `Print.${filetype}`;
        }
        return {
            url: `/filestore/DownloadSrv?notekey=${notekey}&username=${username}&timestamp=${timestamp}&filetype=${filetype}&system=${system}`,
            filename: newFileName
        };
    }
    openFile(url, newFileName, openInBrowser) {
        if (openInBrowser)
            Util.openDownloadLinkInNewTab(url);
        else
            Util.fetchPrint(url, '', newFileName);
    }
    openBase64File(data, iOpt) {
        const parms = JSON.parse(atob(iOpt));
        const url = Util.createBase64Url(data, parms.mimetype);
        if (parms.openInBrowser) {
            //Util.openDownloadLinkInNewTab(url) //no bueno, no top-frame navigation in Chrome
            const iFrame = `<iframe width="100%" height="99%" src="${url}"></iframe>`;
            const xwin = window.open();
            if (xwin) {
                xwin.document.open();
                xwin.document.write(iFrame);
                xwin.document.close();
            }
        }
        else
            Util.downloadBase64(url, parms.newFileName);
    }
    openPrint(iData) {
        var _a, _b, _c, _d;
        let arr = iData.split(',');
        let inputfile;
        let outputfile;
        let system;
        let curLine;
        for (let i = 0; i < arr.length; i++) {
            curLine = (_a = arr[i]) !== null && _a !== void 0 ? _a : '';
            if (curLine === null || curLine === void 0 ? void 0 : curLine.startsWith('inputfile')) {
                inputfile = (_b = curLine.split('=')[1]) !== null && _b !== void 0 ? _b : '';
            }
            else if (curLine === null || curLine === void 0 ? void 0 : curLine.startsWith('outputfile')) {
                outputfile = (_c = curLine.split('=')[1]) !== null && _c !== void 0 ? _c : '';
            }
            else if (curLine === null || curLine === void 0 ? void 0 : curLine.startsWith('system')) {
                system = (_d = curLine.split('=')[1]) !== null && _d !== void 0 ? _d : '';
            }
        }
        return this.requestfileposter('../print/PDFSrv', inputfile, system).then((res) => {
            let resType = res.getResponseHeader('Content-Type');
            let blob = res.response;
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = outputfile;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }
    getPICInputFields(node, PICFieldList) {
        if (node) {
            if (node instanceof PICInput || node instanceof PICWebTable) {
                PICFieldList.push(node);
            }
            this.getPICInputFields(node.firstElementChild, PICFieldList);
            this.getPICInputFields(node.nextSibling, PICFieldList);
        }
        else
            return;
    }
    getFormData(e) {
        if (e) {
            let PICFieldList = [];
            let body = document.querySelector('body');
            let formElm = document.PICForm;
            let loadPageParentArr = e.composedPath().filter(p => p instanceof PICLoadPage);
            let loadPageParent;
            if (loadPageParentArr && loadPageParentArr.length > 0) {
                loadPageParent = loadPageParentArr[0];
                formElm = loadPageParent.shadowRoot.getElementById('PICSubForm');
                body = loadPageParent.shadowRoot.querySelector('body');
            }
            this.getPICInputFields(body, PICFieldList);
            let fieldMap = new Map(PICFieldList.map(e => { return [e.id, e]; }));
            let tmpForm = fetchFormData.makePicQuery(false, formElm, fieldMap);
            let formOf = typeof tmpForm === 'string' ? String(tmpForm) : '';
            return formOf;
        }
    }
    render() {
        return nothing;
    }
};
__decorate([
    property({ converter: stringDecoder, attribute: 'id' })
], PICAction.prototype, "id_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'pp' })
], PICAction.prototype, "progpath_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'trigger' })
], PICAction.prototype, "trigger_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'boundfld' })
], PICAction.prototype, "bndFldID_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'type' })
], PICAction.prototype, "type_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'parms' })
], PICAction.prototype, "parms_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'event' })
], PICAction.prototype, "event_", void 0);
PICAction = __decorate([
    customElement('pic-action')
], PICAction);
export { PICAction };
//# sourceMappingURL=PICAction.js.map